/** @format */

// 特殊放行原因， 00：无入场记录 01：军警公务车 02：设备故障 03：支付未下发 04:其他
export enum SpecialExitParkReason {
  NoEnter = '00',
  PliceCar = '01',
  InsideCar = '02',
  MonthCarUser = '03',
  PayOnline = '04',
  OweFeeLeave = '05',
  OTHER = '99'
}

export const SpecialExitParkReasonMap: {
  [key: string]: string;
} = {
  [SpecialExitParkReason.NoEnter]: '无入场记录',
  [SpecialExitParkReason.PliceCar]: '公务车',
  [SpecialExitParkReason.InsideCar]: '内部车',
  [SpecialExitParkReason.MonthCarUser]: '月卡用户',
  [SpecialExitParkReason.PayOnline]: '线上支付未下发',
  [SpecialExitParkReason.OweFeeLeave]: '欠费离场',
  [SpecialExitParkReason.OTHER]: '其他'
};

// 审核状态  00 01 02 分别表示未通过 已通过 待审核
export enum ReviewStatus {
  NotPass = '00',
  Passed = '01',
  TBD = '02'
}

export const ReviewStatusMap: {
  [key: string]: string;
} = {
  [ReviewStatus.NotPass]: '未通过',
  [ReviewStatus.Passed]: '已通过',
  [ReviewStatus.TBD]: '待审核'
};

// 进出场类型  00 01 分别表示未通过 进 出
export enum DirectionType {
  IN = '00',
  OUT = '01'
}

export const DirectionTypeMap: {
  [key: string]: string;
} = {
  [DirectionType.IN]: '进场',
  [DirectionType.OUT]: '出场'
};

// 抬杆方式  00 01 02 分别表示遥控器 岗亭 远程
export enum LiftTypes {
  RemoteControl = '01',
  SentryBox = '02',
  Distance = '03'
}

export const LiftTypesMap: {
  [key: string]: string;
} = {
  [LiftTypes.RemoteControl]: '遥控器抬杆',
  [LiftTypes.SentryBox]: '岗亭抬杆',
  [LiftTypes.Distance]: '远程抬杆'
};

// 抬杆原因  00 01 02 03 04 分别表示遥控器 岗亭 远程
export enum LiftCausesTypes {
  DistinguishError = '00',
  Moto = '01',
  Bicycle = '02',
  DeviceError = '03',
  NoPlate = '04',
  NBCar = '05',
  InsideCar = '06',
  Other = '99'
}

export const LiftCausesTypesMap: {
  [key: string]: string;
} = {
  [LiftCausesTypes.DistinguishError]: '车牌未识别',
  [LiftCausesTypes.Moto]: '摩托车',
  [LiftCausesTypes.Bicycle]: '非机动车',
  [LiftCausesTypes.DeviceError]: '设备故障',
  [LiftCausesTypes.NoPlate]: '无牌车',
  [LiftCausesTypes.NBCar]: '公务车',
  [LiftCausesTypes.InsideCar]: '内部车',
  [LiftCausesTypes.Other]: '其他'
};

//车辆修正下发状态 ：00 下发失败，01 下发成功，02 下发中，03 无需下发
export enum RepaireRecordIssuedStatus {
  Fail = '00',
  Success = '01',
  InProgress = '02',
  NoNeed = '03'
}

export const RepaireRecordIssuedStatusMap: {
  [key: string]: string;
} = {
  [RepaireRecordIssuedStatus.Fail]: '下发失败',
  [RepaireRecordIssuedStatus.Success]: '下发成功',
  [RepaireRecordIssuedStatus.InProgress]: '下发中',
  [RepaireRecordIssuedStatus.NoNeed]: '无需下发'
};

//应收未收补缴状态 ：00 待补缴，01 已补缴
export enum PayBackStatus {
  NotPay = '00',
  AlreadyPay = '01'
}

export const payBackStatusMap: {
  [key: string]: string;
} = {
  [PayBackStatus.NotPay]: '未补缴',
  [PayBackStatus.AlreadyPay]: '已补缴'
};

//应收未收补缴方式 ：00 现金
export enum PayBackWay {
  Cash = '00'
}

export const PayBackWayMap: {
  [key: string]: string;
} = {
  [PayBackWay.Cash]: '现金'
};

//应收未收类型 ：00 现金
export enum UncollectedTypes {
  FollowPrevCar = '00',
  SpecialEscape = '01'
}

export const uncollectedTypesMap: {
  [key: string]: string;
} = {
  [UncollectedTypes.FollowPrevCar]: '跟车出场',
  [UncollectedTypes.SpecialEscape]: '特殊放行'
};
